import { EnterpriseSearchService, ServiceType } from '@sabstravtech/obtservices/angular';
import { FerryEnterpriseSearchInterface } from '@sabstravtech/obtservices/base';
import { Component, Input } from '@angular/core';

import { ProductLoadingScreen } from './product-loading-screen';

@Component({
  selector: 'app-ferry-loading-screen',
  templateUrl: './ferry-loading-screen.component.html',
  styleUrls: [],
  standalone: false
})
export class FerryLoadingScreenComponent extends ProductLoadingScreen<FerryEnterpriseSearchInterface> {
  @Input() animated = true;
  constructor(service: EnterpriseSearchService) {
    super(service, service.searches[ServiceType.Ferry]);
  }
}
